export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Área',
                    type: 'custom-html',
                    key: 'area',
                    modifier: (value) => {
                        if(value){
                            return value.name;
                        }else{
                            return value;
                        }
                    }
                },
                {
                    title: 'Nombre',
                    type: 'custom-html',
                    key: 'name',
                    modifier: (value) => {
                        return value;
                    }
                },
                
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'type',
                    modifier: (value) => {
                        if(value == 0){
                            return 'In Situ';
                        }else{
                            return 'Evaluación Remota'
                        }
                    }
                },
            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}